import React from 'react';
import { StitchLine } from './StitchLine';
interface SectionHeadingProps {
  id?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}

/** Serif section title with a short running stitch and optional intro. */
export function SectionHeading({
  id,
  title,
  intro,
  align = 'left',
  tone = 'light'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-154" data-mp="bler7jqyo2yx">
      <StitchLine className={`w-16 ${centered ? 'mx-auto' : ''}`} data-id="element-155" data-mp="gjzsznlv2uph" />
      <h2 id={id} className={`mt-4 font-serif text-[2rem] font-semibold leading-[1.1] text-balance sm:text-[2.5rem] lg:text-[2.85rem] ${tone === 'dark' ? 'text-white' : 'text-graphite'}`} data-id="element-156" data-mp="glavzl7hfyfj">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-[1.06rem] leading-relaxed text-pretty sm:text-[1.13rem] ${tone === 'dark' ? 'text-white/85' : 'text-graphite-soft'}`} data-id="element-157" data-mp="uhwqqnc1x75q">
          {intro}
        </p>}
    </div>;
}